import request from '@/utils/request'

// 查询推送通知管理列表
export function listPushNotice(query) {
  return request({
    url: '/system/push/notice/list',
    method: 'get',
    params: query
  })
}

// 查询推送通知管理详细
export function getPushNotice(id) {
  return request({
    url: '/system/push/notice/' + id,
    method: 'get'
  })
}

// 新增推送通知管理
export function addPushNotice(data) {
  return request({
    url: '/system/push/notice',
    method: 'post',
    data: data
  })
}

// 修改推送通知管理
export function updatePushNotice(data) {
  return request({
    url: '/system/push/notice',
    method: 'put',
    data: data
  })
}

// 删除推送通知管理
export function delPushNotice(id) {
  return request({
    url: '/system/push/notice/' + id,
    method: 'delete'
  })
}

// 立即推送通知
export function pushNow(id) {
  return request({
    url: '/system/push/notice/push/now/' + id,
    method: 'post'
  })
}
